export const GoogleMapApiConfig = 'AIzaSyBXFK0ckK7ff6CxuLZb4kEpY0HlF0PMg84';